import * as React from "react";
import { memo } from "react";
import { ToolProgressInterface } from "../../../app/services/CustomEndpointChatService";
import styles from "./ToolProgressList.module.scss";

interface ToolProgressListProps {
    progress: ToolProgressInterface[];
}

/**
 * Renders agent tool progress entries (emoji, tool name, label, status).
 * Completed/failed entries render statically; running entries show a spinner.
 */
const ToolProgressList = memo(({ progress }: ToolProgressListProps) => {
    if (!progress?.length) {
        return null;
    }

    return (
        <div className={styles.toolProgressBlock}>
            {progress.map((entry, index) => (
                <div key={entry.toolCallId || `tool-progress-${index}`} className={styles.toolProgressEntry}>
                    <span className={styles.toolProgressEmoji}>{entry.emoji ?? '🔧'}</span>
                    <span className={styles.toolProgressName}>{entry.tool}</span>
                    {entry.label && entry.label !== '*' && (
                        <span className={styles.toolProgressLabel}>{entry.label}</span>
                    )}
                    <span className={[
                        styles.toolProgressStatus,
                        entry.status === 'running' ? styles.toolProgressStatusRunning
                            : entry.status === 'failed' ? styles.toolProgressStatusFailed
                                : styles.toolProgressStatusCompleted
                    ].join(' ')}>
                        {entry.status === 'running' && <span className={styles.toolProgressSpinner} />}
                        {entry.status}
                    </span>
                </div>
            ))}
        </div>
    );
});

export default ToolProgressList;
